import { isString } from 'lodash';

export const jsonParse = (...args) => JSON.parse(...args);

export const jsonStringify = (...args) => JSON.stringify(...args);

export const safeJsonParse = (value, fallback = null) => {
  if (!isString(value)) {
    return value ?? fallback;
  }

  try {
    return jsonParse(value);
  } catch {
    return fallback;
  }
};

export const safeJsonStringify = (value, fallback = '') => {
  try {
    return jsonStringify(value);
  } catch {
    return fallback;
  }
};

export const parseJSONObject = json => (isString(json) ? safeJsonParse(json, {}) : json);

export const stringifyJSONObject = value => (isString(value) ? value : jsonStringify(value || {}));
